export default "__VITE_ASSET__MoHxexr$__"